import { Table } from "antd";
import axios from "axios";
import React from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { serverUrl } from "../../../../nestserver";

/**
 * Admin's Course Board landing table — same shape as the instructor's
 * (apps/instructor/pages/CourseBoard/index.js), reusing SwitchCourseTab for
 * the detail view, but sourced from admin-safe, school-wide endpoints
 * instead of the instructor's own teacher-scoped ones:
 *
 * - Classes for the filter dropdown: GET /classes (school-scoped, not
 *   GET /teachers/classes, which 500s for an admin caller — that endpoint
 *   resolves req.user.user.teacher, which doesn't exist on an admin).
 * - The row data itself: GET /subjects (also school-scoped), not
 *   user.teacher.subjects off Redux, which is always empty for admin.
 */
const AdminCourseBoard = () => {
  const navigate = useNavigate();

  async function fetchClasses() {
    const res = await axios({
      method: "get",
      url: serverUrl + "/classes",
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });
    return res.data;
  }
  const classes = useQuery("admin-course-board-classes", fetchClasses);

  async function fetchSubjects() {
    const res = await axios({
      method: "get",
      url: serverUrl + "/subjects",
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });
    return res.data;
  }
  const subjects = useQuery("admin-course-board-subjects", fetchSubjects);

  const columns = [
    {
      title: "Class",
      key: "class",
      align: "center",
      render: (record) => (
        <div
          style={{ color: "#111111" }}
          className="text-base font-semibold text-center"
        >
          {record?.class?.name}
        </div>
      ),
      filters: classes.isSuccess
        ? classes.data.map((c) => ({ text: c.name, value: c._id }))
        : [],
      onFilter: (value, record) => record?.class?._id === value,
    },
    {
      title: "Subject",
      dataIndex: "name",
      key: "name",
      align: "center",
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (record) => (
        <div
          className="text-base font-semibold text-center text-blue-500 cursor-pointer"
          onClick={() =>
            navigate(
              `/dashboard/admin/menu/course-board/${record?.class?.name}/${record?.class?._id}/${record?._id}`,
            )
          }
        >
          Click to view
        </div>
      ),
    },
  ];

  return (
    <div className="p-8">
      <div
        style={{ borderRadius: "10px", color: "#616161" }}
        className="bg-white drop-shadow-md p-8 w-full"
      >
        <div className="text-2xl text-orange-500 font-semibold pb-6">
          Course Board
        </div>
        <Table
          columns={columns}
          dataSource={subjects.data || []}
          loading={subjects.isLoading}
          rowKey={(r) => r._id}
          pagination={false}
        />
      </div>
    </div>
  );
};

export default AdminCourseBoard;
